import styles from "./ModalCheckup.module.css";
import { useModal } from "../../hooks/useModalHook";
import { Link } from "react-router-dom";
import { useState, useMemo } from "react";
import { useForm } from "react-hook-form";
import { IMaskInput } from "react-imask";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import Typograf from "typograf";
import Hypher from "hypher";
import russian from "hyphenation.ru";
// removed local GoogleReCaptchaProvider, now using global provider in App
const ModalCheckup = (props) => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const { openModal, closeModal } = useModal()
  const { register, handleSubmit, setValue, formState: { isSubmitting, errors }, reset } = useForm();
  const [phoneMask, setPhoneMask] = useState("");

  const tp = useMemo(() => {
    const typograf = new Typograf({ locale: ["ru", "en-US"] });
    return typograf;
  }, []);
  
  const h = useMemo(() => new Hypher(russian), []);
  
  const consentText = useMemo(() => tp.execute("Нажимая кнопку «Отправить», я"), [tp]);
  
  const hyphenatedWord = useMemo(() => {
    return h.hyphenateText("принимаю").replace(/-/g, '\u00AD');
  }, [h]);

  // Используем только props.checkup (один объект)
  const checkup = props.checkup;

  // Защита от отсутствия checkup
  if (!checkup) {
    return <div className={styles.modalcheckup}><div className={styles.info_wrapper}>Нет данных о чекапе</div></div>;
  }

  const onSubmit = async (data) => {
    if (!executeRecaptcha) {
      alert("Сервис защиты временно недоступен. Попробуйте позже.");
      return;
    }
    const token = await executeRecaptcha("submit");
    const payload = { ...data, recaptchaToken: token };
    try {
      const res = await fetch("/sendAppointment.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const json = await res.json();
      if (!res.ok || json.status !== "success") {
        throw new Error(json.message || `HTTP ${res.status}`);
      }
      closeModal();
      setTimeout(() => openModal("success"), 100);
      if (window.ym) {
        window.ym(9956731, "reachGoal", "zapis_form_send");
      }
      // Очистка формы
      reset();
      setPhoneMask("");
    } catch (err) {
      alert("Ошибка отправки: " + err.message);
    }
  };

  return (
    <div className={styles.modalcheckup}>
      <div className={styles.info_wrapper}>
        <h3 className={styles.modal_checkups_heading}>{checkup && checkup.name ? checkup.name : "Чекап"}</h3>
        <p className={styles.price}>{checkup && checkup.price ? checkup.price + " руб." : null}</p>
        {Array.isArray(checkup.visits) && checkup.visits.map((visit, idx) => (
          <div key={idx}>
            <p className={styles.visit}>{visit.name}{visit.offset_days ? ` (через ${visit.offset_days} рабочих дней)` : null}:</p>
            {Array.isArray(visit.services) && visit.services.length > 1 ? (
              <ol className={styles.list}>
                {visit.services.map((service, i) => (
                  <li className={styles.list_item} key={i}>{service}</li>
                ))}
              </ol>
            ) : (
              Array.isArray(visit.services) && visit.services.length === 1 ? (
                <p className={styles.item}>{visit.services[0]}</p>
              ) : null
            )}
          </div>
        ))}


        <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
          <div className={styles.form_inputs_wrapper}>
            <label className={styles.form_label}>
              <input
                className={styles.form_input}
                type="text"
                id="name"
                placeholder="Ваше ФИО"
                {...register("name", { required: "Введите ФИО" })}
              />
            </label>
            <label className={styles.form_label}>
              <IMaskInput
                mask="+7 (000) 000-00-00"
                definitions={{ 0: /\d/ }}
                unmask={false}
                placeholder="Тел. +7 (___) ___-__-__"
                className={styles.form_input}
                type="tel"
                inputMode="tel"
                value={phoneMask}
                onAccept={val => {
                  setPhoneMask(val);
                  setValue("phone", val, { shouldValidate: true });
                }}
                {...register("phone", {
                  required: "Введите номер телефона",
                  pattern: {
                    value: /^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/,
                    message: "Введите корректный номер телефона"
                  }
                })}
              />
            </label>
            <label className={styles.form_label}>
              <input
                className={styles.form_input}
                type="email"
                id="email"
                placeholder="E-mail"
                {...register("email", {
                  required: "Введите email",
                  pattern: {
                    value: /^\S+@\S+\.\S+$/,
                    message: "Введите корректный email"
                  }
                })}
              />
            </label>
          </div>
          <div className={styles.form_button_action_wrapper}>
            <button
              type="submit"
              className={styles.form_button_action + " light_sweep"}
              disabled={isSubmitting}
            >
              <span className={styles.form_button_span}>
                {isSubmitting ? "Отправка…" : "Записаться"}
              </span>
            </button>
          </div>
          <div className={styles.checkbox_wrapper}>
            <div className={styles.checkbox_label}>
              <label>
                <input
                  type="checkbox"
                  className={styles.checkbox_input}
                  {...register("consent", { required: "Необходимо принять условия обработки информации" })}
                />
              </label>
              <span className={styles.checkbox_text}>
                  {consentText} {hyphenatedWord}{' '}
                  <Link
                    className={styles.cookieLink}
                    to="/polzovatelskoe-soglashenie"
                  >
                    условия обработки информации
                  </Link>
                </span>
            </div>
            {errors.consent && (
              <div className={styles.error_message}>
                {errors.consent.message}
              </div>
            )}
          </div>
        </form>
      </div>
      <img className={styles.img} src={checkup.img} />
    </div>
  );
};

export default ModalCheckup;
